import '@/i18n';
import React from 'react';
import { AppRouter } from '@/AppRouter';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';

export function App() {
  return (
    <ErrorBoundary>
      <AppRouter />
    </ErrorBoundary>
  );
}
